import { useGraphQLQuery } from '@betterment/js-runtime';

import {
  IraContributionsAllTimeQueryResult,
  IraContributionsByYearQueryResult,
  IraContributionsCurrentYearQueryResult,
} from './data';
import { IraContributionsAllTimeDocument } from './graphql/query.iraContributionsAllTime.generated';
import { IraContributionsByYearDocument } from './graphql/query.iraContributionsByYear.generated';
import { IraContributionsCurrentYearDocument } from './graphql/query.iraContributionsCurrentYear.generated';

export const useIraContributionsCurrentYearQuery = (): IraContributionsCurrentYearQueryResult => {
  const currentYear = new Date().getFullYear();
  const { data } = useGraphQLQuery(IraContributionsCurrentYearDocument, {
    throwOnError: true,
    variables: { currentYear },
  });

  const isLoading = !data;

  return {
    isLoading,
    iraContributionCurrentYear: data?.iraContributions?.byYear[0],
  };
};

export const useIraContributionsAllTimeQuery = (): IraContributionsAllTimeQueryResult => {
  const { data } = useGraphQLQuery(IraContributionsAllTimeDocument, { throwOnError: true });

  const isLoading = !data;

  return {
    isLoading,
    iraContributionsAllTime: data?.iraContributions?.allTime,
  };
};

export const useIraContributionsByYearQuery = (): IraContributionsByYearQueryResult => {
  const { data } = useGraphQLQuery(IraContributionsByYearDocument, { throwOnError: true });

  const isLoading = !data;

  return {
    isLoading,
    iraContributionByYear: data?.iraContributions?.byYear,
  };
};
